import { getWindowWidth } from "../functions.js";

export default function OurApproachModule(element) {
    let tl = gsap.timeline({
        scrollTrigger: { 
            trigger: element, 
            start: 'top bottom', 
        }
    });

    let items = element.querySelectorAll('.approach__item');

    if (getWindowWidth() > 991) {
        items = [...items].reverse();
    }

    items.forEach(function(subelem, index) {
        tl.from(subelem, {x: -400 + (index * 50), opacity: 0}, '<0.1');
    });

    return this;
}
